import { QueryClient } from '@tanstack/react-query'

// Single shared client so main.tsx can prefetch the first data load (and fade the branded
// preloader out when it settles) using the same cache the React components read from.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, retry: 1 },
  },
})
